export default __webpack_public_path__ + "static/wallpaper-4-mb-3f5a42b7bbe2b110968e268572a9bc82.png";